import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Spinner } from "@/components/Kit";
import { Cpu, ArrowRight } from "lucide-react";

export default function Onboarding({ onDone }) {
  const [entering, setEntering] = useState(false);
  const [cleared, setCleared] = useState(false);

  const enter = async () => {
    setEntering(true);
    try { await api.post("/onboard", {}); } catch { toast.error("Boot sequence hiccup — entering anyway."); }
    setCleared(true);
    setTimeout(() => onDone?.(), 900);
  };

  return (
    <div data-testid="onboarding-overlay" className="fixed inset-0 z-[100] overflow-hidden bg-background"
      style={{ transition: "opacity 0.9s ease", opacity: cleared ? 0 : 1, pointerEvents: cleared ? "none" : "auto" }}>
      {/* industrial smoke haze */}
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="absolute rounded-full blur-3xl"
          style={{
            width: "60vw", height: "60vw",
            left: `${[-10, 40, 15, 65, 25][i]}%`, top: `${[10, -5, 50, 35, 70][i]}%`,
            background: i % 2 ? "radial-gradient(circle, hsl(var(--primary)/0.18), transparent 70%)" : "radial-gradient(circle, hsl(var(--muted-foreground)/0.22), transparent 70%)",
            animation: `smokeDrift ${8 + i * 2}s ease-in-out ${i * 0.6}s infinite alternate`,
          }} />
      ))}
      <style>{`@keyframes smokeDrift{0%{transform:translate(0,0) scale(1)}100%{transform:translate(6%,-4%) scale(1.15)}}`}</style>

      <div className="relative h-full grid place-items-center px-6 text-center">
        <div className="max-w-md pop-in">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/15 grid place-items-center text-primary mb-5 animate-pulse"><Cpu className="w-9 h-9" /></div>
          <div className="label-cap text-primary mb-2">Airlock cycling · station boot sequence</div>
          <h1 className="font-head font-black text-4xl sm:text-5xl tracking-tighter mb-3">Welcome to Orbit</h1>
          <p className="text-muted-foreground mb-8">You've docked at the station orbiting a mysterious planet. The maintenance smoke is clearing — head to the Assembly Bay to fabricate your first robot companion and begin your ascent to Security Clearance Level 5.</p>
          <button onClick={enter} disabled={entering} data-testid="onboarding-enter" className="btn-primary mx-auto px-8 py-3 text-base">
            {entering ? <Spinner className="w-4 h-4" /> : <>Enter the Station <ArrowRight className="w-4 h-4" /></>}
          </button>
        </div>
      </div>
    </div>
  );
}
